var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLptIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 24.5H1.74999C1.48749 24.5 1.13749 24.325 0.962488 24.0625C0.787488 23.8 0.787488 23.45 0.962488 23.1875L2.71249 20.5625C2.88749 20.3 3.14999 20.125 3.49999 20.125H24.5C24.85 20.125 25.1125 20.3 25.2875 20.65L27.0375 23.275C27.2125 23.5375 27.125 23.8875 27.0375 24.15C26.8625 24.325 26.5125 24.5 26.25 24.5Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 4.375H4.375C3.85 4.375 3.5 4.725 3.5 5.25V17.5C3.5 18.025 3.85 18.375 4.375 18.375H23.625C24.15 18.375 24.5 18.025 24.5 17.5V5.25C24.5 4.725 24.15 4.375 23.625 4.375ZM10.2375 13.3875C10.5875 13.7375 10.5875 14.2625 10.2375 14.6125C10.0625 14.7875 9.8875 14.875 9.625 14.875C9.3625 14.875 9.1875 14.7875 9.0125 14.6125L6.3875 11.9875C6.0375 11.6375 6.0375 11.1125 6.3875 10.7625L9.0125 8.1375C9.3625 7.7875 9.8875 7.7875 10.2375 8.1375C10.5875 8.4875 10.5875 9.0125 10.2375 9.3625L8.225 11.375L10.2375 13.3875ZM16.5375 8.225L13.0375 15.225C12.8625 15.575 12.6 15.75 12.25 15.75C12.075 15.75 11.9875 15.75 11.9 15.6625C11.4625 15.4875 11.2875 14.9625 11.55 14.525L15.05 7.525C15.225 7.0875 15.75 6.9125 16.1875 7.175C16.5375 7.35 16.7125 7.875 16.5375 8.225ZM21.6125 11.9875L18.9875 14.6125C18.8125 14.7875 18.6375 14.875 18.375 14.875C18.1125 14.875 17.9375 14.7875 17.7625 14.6125C17.4125 14.2625 17.4125 13.7375 17.7625 13.3875L19.775 11.375L17.7625 9.3625C17.4125 9.0125 17.4125 8.4875 17.7625 8.1375C18.1125 7.7875 18.6375 7.7875 18.9875 8.1375L21.6125 10.7625C21.9625 11.1125 21.9625 11.6375 21.6125 11.9875Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 17,
    height: 11,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLptIconWhite);
export default __webpack_public_path__ + "static/media/lpt-icon-white.724eeafd7b3f0b29d8b63e1893921d75.svg";
export { ForwardRef as ReactComponent };